import React from 'react';
import { isNullOrUndefined } from '../../../Util/TypeGuards';
import { Tag } from './CheckIn/FerryCheckIn/CheckInList/Tag';

export function UserDisplayNameTag(displayName?: string | null) {
	if (isNullOrUndefined(displayName)) {
		return <></>;
	}
	return <Tag text={displayName} />;
}

export function UserDisabledTag() {
	return <Tag text="Deactivated" tagClassName="tag--error" />;
}

export function UserUnverifiedTag() {
	return <Tag text="Unverified" tagClassName="tag--error" />;
}
